import { render, staticRenderFns } from "./SnookerRoom.vue?vue&type=template&id=8addec64&"
import script from "./SnookerRoom.vue?vue&type=script&lang=js&"
export * from "./SnookerRoom.vue?vue&type=script&lang=js&"
import style0 from "./SnookerRoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports